import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// models {
import { MixpanelEvents } from '../../models/mixpanelEvents';
import { PlatformApplications } from '../../models/platformApplications';

// services
import { MixpanelService } from '../../services/mixpanel.service';
import { SessionService } from '../../services/session.service';

@Component({
    selector: 'app-get-full-version-modal',
    templateUrl: './get-full-version-modal.component.html',
    styleUrls: ['./get-full-version-modal.component.scss'],
    standalone: false
})
export class GetFullVersionModalComponent {

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { title?: string },
		private dialogRef: MatDialogRef<GetFullVersionModalComponent>,
		private mixpanelService: MixpanelService,
		private sessionService: SessionService
	) {
		this.dialogRef
			.beforeClosed()
			.subscribe((result: boolean) => {
				if (result === undefined) this.close();
			});
	}

	apply(): void {
		this.mixpanelService.trackPage(MixpanelEvents.OnboardingFullVersion, { event: 'APPLY' });
		window.open(
			this.sessionService.getExternalLink(PlatformApplications.AdminPanel, '/tariff-plans'),
			'_blank'
		);
		this.dialogRef.close(true);
	}

	cancel(): void {
		this.mixpanelService.trackPage(MixpanelEvents.OnboardingFullVersion, { event: 'CANCEL' });
		this.dialogRef.close(false);
	}

	close(): void {
		this.mixpanelService.trackPage(MixpanelEvents.OnboardingFullVersion, { event: 'CLOSE' });
		this.dialogRef.close(false);
	}
}
